import { render, staticRenderFns } from "./WaterMark.vue?vue&type=template&id=64bec88e&scoped=true&"
import script from "./WaterMark.vue?vue&type=script&lang=js&"
export * from "./WaterMark.vue?vue&type=script&lang=js&"
import style0 from "./WaterMark.vue?vue&type=style&index=0&id=64bec88e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bec88e",
  null
  
)

export default component.exports